export function parseIndividualDelivery(value: unknown): boolean {
  if (value == null || value === '') return false;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (['', 'n', 'no', 'x', '0', 'false'].includes(normalized)) return false;
  if (['y', 'yes', 'o', '1', 'true'].includes(normalized)) return true;
  throw new Error('개별배송은 Y 또는 N으로 입력해주세요.');
}

export function parseIndividualDeliveryPrice(value: unknown): number {
  if (value == null || (typeof value === 'string' && !value.trim())) return 0;
  const price = typeof value === 'number' || typeof value === 'string' ? Number(value) : NaN;
  if (!Number.isSafeInteger(price) || price < 0 || price > 2147483647) {
    throw new Error('개별배송비는 0원 이상의 정수로 입력해주세요.');
  }
  return price;
}
